









import Vue from 'vue';
import { ModalMixin, Modal } from 'mycorems-app-shared';
import EmailCampaignPreview from './EmailCampaignPreview.vue';

export default Vue.extend({
  mixins: [ModalMixin],
  props: {
    url: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: 'Email Campaign Preview',
    },
  },
  components: {
    Modal,
    EmailCampaignPreview,
  },
});
